import MobileHeader from '../../components/mobile/MobileHeader';
import MobileMemberDashboard from '../../components/mobile/MobileMemberDashboard';
import MobileBottomNav, { type NavItem } from '../../components/mobile/MobileBottomNav';
import { NotificationCenter } from '../../components/common/NotificationCenter/NotificationCenter';
import { useUnreadNotifications } from '../../hooks/useUnreadNotifications';
import type { Notification } from '../../services/notificationsApi';

const MobileMemberDashboardPage = () => {
  const { unreadCount } = useUnreadNotifications();

  const handleNotificationClick = (notification: Notification) => {
    console.log('Notification clicked:', notification);
    // Could add navigation logic here based on notification type
  };

  // Create nav items with badge
  const navItems: NavItem[] = [
    {
      id: 'home',
      label: '首頁',
      path: '/',
      icon: '🏠',
    },
    {
      id: 'ads',
      label: '廣告',
      path: '/ads',
      icon: '🛒',
    },
    {
      id: 'wish',
      label: '願望',
      path: '/wishes',
      icon: '⭐',
    },
    {
      id: 'profile',
      label: '會員',
      path: '/member',
      icon: '👤',
      badge: unreadCount > 0 ? unreadCount.toString() : undefined,
    },
  ];

  return (
    <div>
      <MobileHeader
        title="會員中心"
        showBack={false}
        rightAction={<NotificationCenter onNotificationClick={handleNotificationClick} />}
      />
      <MobileMemberDashboard />
      <MobileBottomNav items={navItems} />
    </div>
  );
};

export default MobileMemberDashboardPage;
